import { RouterProvider } from 'react-router-dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import useConfig from 'hooks/useConfig';
import PrivateKeyProvider from 'contexts/PrivateKeyContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //
declare var $: any;

const App = () => {
  const { mode } = useConfig();
  mode=='light' ? localStorage.setItem('sm-skin','smart-style-2') : localStorage.setItem('sm-skin','smart-style-1')
  mode=='light' ?  $('body').removeClass('smart-style-1') : $('body').removeClass('smart-style-2');
  mode=='light' ?  $('body').addClass('smart-style-2') : $('body').addClass('smart-style-1');
  return( 
  <ThemeCustomization>
    {/* <RTLLayout> */}
    <Locales>
      <ScrollTop>
        <AuthProvider>
          <>
              <PrivateKeyProvider>
                <Notistack>
                  <RouterProvider router={router} />
                  <Snackbar />
                </Notistack>
              </PrivateKeyProvider>
            </>
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>)
}

export default App;
